import { styled, keyframes } from 'styled-components'

const shimmer = keyframes`
  0% {
    background-position: -375px 0;
  }
  100% {
    background-position: 375px 0;
  }
`

export const Skeleton = styled.span`
  display: inline-block;
  vertical-align: middle;
  background: #ebe7e7;
  background-image: linear-gradient(
    to right,
    #ebe7e7 0%,
    #d3cacd 20%,
    #ebe7e7 40%,
    #ebe7e7 100%
  );
  background-repeat: no-repeat;
  background-size: 900px 100%;
  border-radius: 3px;
  animation: ${shimmer} 1.1s linear infinite;
`
